/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_EmptyInputs */

const cs_franchise_empty = /** @type {(inputs: Franchise_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné prodané licence.`)
};

const en_franchise_empty = /** @type {(inputs: Franchise_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No licenses sold yet.`)
};

/**
* | output |
* | --- |
* | "No licenses sold yet." |
*
* @param {Franchise_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_empty = /** @type {((inputs?: Franchise_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_empty(inputs)
	return cs_franchise_empty(inputs)
});